import { kebabCase } from 'lodash'

export const brandKeysByRoute = {
  masterclass: 'CORE',
  'masterclass-at-work': 'AT_WORK',
  oncall: 'ON_CALL',
  certificates: 'CERTIFICATES',
}

export type BrandKey = (typeof brandKeysByRoute)[keyof typeof brandKeysByRoute]

export interface HelpCenterProduct {
  key: string
  slug: string
  name: string
  image: {
    src: string
    alt: string
    className?: string
  }
}

export const productsByKey: Record<BrandKey, HelpCenterProduct> = {
  CORE: {
    key: brandKeysByRoute.masterclass,
    slug: 'masterclass',
    name: 'MasterClass',
    image: {
      src: 'https://static.masterclass.com/help-center-core-logo.svg',
      alt: 'MasterClass',
    },
  },
  ON_CALL: {
    key: brandKeysByRoute.oncall,
    slug: 'oncall',
    name: 'MasterClass OnCall',
    image: {
      src: 'https://static.masterclass.com/help-center-on-call-logo.svg',
      alt: 'MasterClass On Call',
    },
  },
  AT_WORK: {
    key: brandKeysByRoute['masterclass-at-work'],
    slug: 'masterclass-at-work',
    name: 'Masterclass at Work',
    image: {
      src: 'https://static.masterclass.com/help-center-at-work-logo.svg',
      alt: 'Masterclass at Work',
    },
  },
  CERTIFICATES: {
    key: brandKeysByRoute.certificates,
    slug: 'certificates',
    name: 'MasterClass Certificates',
    image: {
      src: 'https://static.masterclass.com/help-center-mc-certificates-logo.png',
      alt: 'Masterclass Certificates',
      className: 'mc-p-4',
    },
  },
}

export const PRODUCTS: HelpCenterProduct[] = [
  productsByKey.CORE,
  productsByKey.ON_CALL,
  productsByKey.AT_WORK,
  productsByKey.CERTIFICATES,
]

export const stripHtmlTags = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, '')

export const genAnswerSlug = (id: string, title: string) =>
  `${kebabCase(stripHtmlTags(title))}--id--${id}`
